import styled from 'styled-components';

export const WorkContatiner = styled.section`
color:white;
font-size:5rem;
padding: 500px 0 500px 0;
position:relative;
text-align: center;
`